export default __webpack_public_path__ + "static/media/nlp.ca8708c9.jpg";